<template>
	<main class="flex column gap-xl">
		<h1 class="font-extralarge ">{{localization.title[locale]}}</h1>
		
		<div class="flex gap-xl">
			<div class="flex column gap-xl col-12">
				<div id="graph" ref="graph">
					<div class="day-label">{{localization.days[locale]}}</div>
					<div class="day-label">{{localization.days[locale]}}</div>
					
					<div class="peak-label">{{localization.peak[locale]}}</div>
						
					<CustomRange 
						class="peak blue" 
						v-model="peak.value"
						@change="updatePeak"
						:min="peak.min" :max="peak.max"
						:style="{
							width : (scales.max_peak-scales.min_peak)+'px',
							marginLeft : scales.min_peak+'px'
						}" 
					></CustomRange>
					
					
					<div class="intervention-label">{{localization.intervention[locale]}}</div>
					
					<div class="intervention-fade"
						:style="{
							top : scales.top+'px',
							left : intervention.scale_value+'px',
							height: (scales.bottom - scales.top)+'px',
							width: (scales.right - intervention.scale_value)+'px',
						}" 
					></div>
						
					<CustomRange 
						class="intervention" 
						v-model="intervention.value"
						@change="updateIntervention"
						:min="intervention.min" :max="Math.floor(peak.value/2)"
						:style="{
							width : (scales.max_intervention-scales.min_intervention)+'px',
							marginLeft : scales.min_intervention+'px'
						}" 
					></CustomRange>
					
					<svg class="play" @click="playAnimation" height="24px" viewBox="0 -960 960 960" width="24px" fill="white"><path d="m380-300 280-180-280-180v360ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
				</div>
				
				<CustomRange 
					class="intervention" 
					v-model="time"
					min="0" :max="length"
					@change="changeTime"
					:style="{
						width : (scales.right-scales.left)+'px',
						marginLeft : scales.left+'px'
					}" 
				></CustomRange>
					
				
				<div class="data flex column gap-xs">
					<h2 class="font-large">{{localization.data[locale]}}</h2>
					<div>{{localization.index[locale]}}</div>
					
					
					<div class="index flex gap-s">
						<div class="entry">
							<svg width="8" height="8" viewBox="0 0 8 8" fill="none"><circle cx="4" cy="4" r="3.5" fill="#BD5EFD" fill-opacity="0.2" stroke="#BD5EFD"/></svg>
							<div class="text">{{localization.reflux[locale]}}</div>
						</div>
					</div>
					
					<div class="index flex gap-s">
						<div class="entry">
							<svg width="44" height="4" viewBox="0 0 44 4" fill="none"><path d="M2 2H42" stroke="#BD5EFD" stroke-width="3" stroke-linecap="round"/></svg>
							<div class="text">{{localization.prevalence[locale]}}</div>
						</div>
						<div class="entry">
							<svg width="44" height="4" viewBox="0 0 44 4" fill="none"><path d="M2 2H42" stroke="#FFA01C" stroke-width="3" stroke-linecap="round"/></svg>
							<div class="text">{{localization.hospitalized[locale]}}</div>
						</div>
						<div class="entry">
							<svg width="44" height="4" viewBox="0 0 44 4" fill="none"><path d="M2 2H42" stroke="#FF5050" stroke-width="3" stroke-linecap="round"/></svg>
							<div class="text">{{localization.deceased[locale]}}</div>
						</div>
					</div>
					
					<div class="index flex gap-s">
						<div class="entry">
							<svg width="44" height="4" viewBox="0 0 44 4" fill="none"><path d="M2 2H42" stroke="#BD5EFD" stroke-width="3" stroke-linecap="round" stroke-dasharray="1 10"/></svg>
							<div class="text">{{localization.with_intervention[locale]}}</div>
						</div>
						<div class="entry">
							<svg width="44" height="4" viewBox="0 0 44 4" fill="none"><path d="M2 2H42" stroke="#FFA01C" stroke-width="3" stroke-linecap="round" stroke-dasharray="1 10"/></svg>
							<div class="text">{{localization.with_intervention[locale]}}</div>
						</div>
						<div class="entry">
							<svg width="44" height="4" viewBox="0 0 44 4" fill="none"><path d="M2 2H42" stroke="#FF5050" stroke-width="3" stroke-linecap="round" stroke-dasharray="1 10"/></svg>
							<div class="text">{{localization.with_intervention[locale]}}</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="side-bar flex column gap-xs">
				<div class="info flex column gap-s">
					<h2 class="font-large">{{localization.title[locale]}}</h2>
					
					<div class="text">{{localization.description[locale]}}</div>
				
					<table>
						<tr>
							<td>{{localization.population[locale]}}</td>
							<td class="small">{{population}}</td>
						</tr>
					</table>
				</div>
				
				<div class="info">
					<table>
						<tr>
							<th></th>
							<th>{{localization.without_intervention[locale]}}</th>
							<th>{{localization.with_intervention[locale]}}</th>
						</tr>
						<tr class="blue">
							<td><span>{{localization.sick[locale]}}</span></td>
							<td><span>{{totalQuote(prevalence_quote)}}</span></td>
							<td><span>{{totalQuote(prevalence_quote_intervention)}}</span></td>
						</tr>
						<tr class="yellow">
							<td><span>{{localization.hospitalized[locale]}}</span></td>
							<td><span>{{totalQuote(prevalence_quote_hospitalized)}}</span></td>
							<td><span>{{totalQuote(prevalence_quote_hospitalized_intervention)}}</span></td>
						</tr>
						<tr class="red">
							<td><span>{{localization.deceased[locale]}}</span></td>
							<td><span>{{totalQuote(prevalence_quote_deceased)}}</span></td>
							<td><span>{{totalQuote(prevalence_quote_deceased_intervention)}}</span></td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
	import * as d3 from "d3";
	var svg, x_scale, y_scale, tween;
	
	import CustomRange from './components/CustomRange.vue'
	import Srand from 'seeded-rand';
	var pdf = require( '@stdlib/stats-base-dists-normal-pdf' )
	import {Tween, Easing} from '@tweenjs/tween.js'

	export default {
		name: 'App',
		components: { CustomRange },
		data: function () { return {
			locale : 'it',
			localization : {
				'title' : {
					'it' : 'STRUMENTO DI SIMULAZIONE EPIDEMICA',		
					'en' : 'EPIDEMIC SIMULATION TOOL'	
				},
				'description' : {
					'it' : 'Questo strumento di simulazione epidemiologica permette di prevedere l’evoluzione di un’epidemia stimando il numero di contagi, ricoveri e decessi attesi. Grazie a modelli matematici, lo strumento consente di esplorare l’evoluzione di possibili scenari alternativi, valutare l’impatto di misure preventive e supportare decisioni rapide e basate su dati, a beneficio di enti sanitari, ricercatori e comunità.',		
					'en' : 'This epidemiological simulation tool makes it possible to forecast the evolution of an epidemic by estimating the expected number of infections, hospitalizations, and deaths. Using mathematical models, the tool enables the exploration of alternative scenarios, the assessment of preventive measures, and the support of rapid, data-driven decisions for the benefit of health authorities, researchers, and communities. '	
				},
				'intervention' : {
					'it' : 'Intervento',		
					'en' : 'Intervention'
				},
				'peak' : {
					'it' : 'Picco',		
					'en' : 'Peak'
				},
				'days' : {
					'it' : 'Giorni',		
					'en' : 'Days'
				},
				'data' : {
					'it' : 'Dati',		
					'en' : 'Data'
				},
				'index' : {
					'it' : 'Reflui = acque inquinate; Prevalenza = numero di persone infette in percentuale.',		
					'en' : 'Wastewater = contaminated water; Prevalence = percentage of infected people.'
				},
				'population' : {
					'it' : 'Popolazione',		
					'en' : 'Population'
				},
				'reflux' : {
					'it' : 'Reflui',		
					'en' : 'Wastewater'
				},
				'prevalence' : {
					'it' : 'Prevalenza',		
					'en' : 'prevalence'
				},
				'sick' : {
					'it' : 'Malati',		
					'en' : 'sick'
				},
				'hospitalized' : {
					'it' : 'Ospitalizzati',		
					'en' : 'hospitalized'
				},
				'deceased' : {
					'it' : 'Decessi',		
					'en' : 'deceased'
				},
				'without_intervention' : {
					'it' : 'Senza intervento',		
					'en' : 'Without intervention'
				},
				'with_intervention' : {
					'it' : 'Con intervento',		
					'en' : 'With intervention'
				}
			},
			graph_sizes : {
				width : 0,
				gap : 50,
				margin_top : 20,
				margin_bottom : 20,
				margin_right : 10,
				margin_left : 110
			},
			scales : {
				top : 0,
				bottom : 0,
				left : 0,
				right : 0,
				min_intervention : 0,
				max_intervention : 0,
				min_peak : 0,
				max_peak : 0
			},
			peak : {
				min : 15,
				max : 75,
				value : 50,
				scale_value : 0,
			},
			intervention : {
				min : 7,
				value : 25,
				scale_value : 0
			},
			
			dots : null,
			curve : null,
			curve_intervention : null,
			hospitalized_curve : null,
			hospitalized_curve_intervention : null,
			deceased_curve : null,
			deceased_curve_intervention : null,
			
			data : [],
			length : 150,
			population : 1000000,
			normal_multiplier : 200,
			hospitalized_reducer : 2,
			hospitalized_reducer_intervention : 3,
			deceased_reducer : 5,
			deceased_reducer_intervention : 10,
			delay_hospitalized : 2,
			delay_deceased : 4,
			sickness_duration : 10,
			
			time : 150,
		}},
		computed: {
			standard_deviation(){
				return this.peak.value/2;
			},
			normal_multiplier_intervention(){
				return this.curveFunction(this.intervention.value) / pdf(this.intervention.value, this.peak.value, this.standard_deviation_intervention);
			},
			standard_deviation_intervention(){
				return this.standard_deviation*1.75;
			},
			rand_data(){
				let rnd = new Srand(5);
				return this.data.map( d => {
					return {x:d.x, y:d.y + rnd.inRange(-0.3, 0.3)} 
				});
			},
			data_intervention(){
				return this.data
					.filter( d => d.x >= this.intervention.value )
					.map( d => {
						if(d.x <= this.intervention.value){
							return d;
						}else{
							return {x:d.x, y:this.curveFunctionIntervention(d.x)}
						}
					});
			},
			hospitalized_data(){
				return this.data
					.map( d => {
						return {x:d.x, y:this.curveFunctionHospitalized(d.x)}
					});
			},
			hospitalized_data_intervention(){
				return this.data
					.filter( d => d.x >= this.intervention.value+this.delay_hospitalized )
					.map( d => {
						return {x:d.x, y:this.curveFunctionHospitalizedIntervention(d.x)}
					});
			},
			deceased_data(){
				return this.data
					.map( d => {
						return {x:d.x, y:this.curveFunctionDeceased(d.x)}
					});
			},
			deceased_data_intervention(){
				let a =  this.data
					.filter( d => d.x >= this.intervention.value+this.delay_deceased )
					.map( d => {
						return {x:d.x, y:this.curveFunctionDeceasedIntervention(d.x)}
					});
				return a
			},
			max_y(){
				return this.data.reduce( (r, d) => {
					return d.y > r ? d.y : r;
				}, 0);
			},
			
			/* CALCOLI SOMME */
			
			prevalence_quote(){
				let result = [];
				for(var i=0; i<=this.length; i++){
					result.push( this.normal_multiplier*pdf(i, this.peak.value, this.standard_deviation) );
				}
				return result;
			},
			prevalence_quote_intervention(){
				let result = [];
				for(var i=0; i<=this.length; i++){
				
					if(i < this.intervention.value){
						result.push( this.normal_multiplier*pdf(i, this.peak.value, this.standard_deviation) );
					}else{
						result.push( this.normal_multiplier_intervention*pdf(i, this.peak.value, this.standard_deviation_intervention) );
					}
				}
				return result;
			},
			prevalence_quote_hospitalized(){
				let result = [];
				for(var i=0; i<=this.length; i++){
					result.push( this.normal_multiplier/this.hospitalized_reducer * pdf(i, this.peak.value+this.delay_hospitalized, this.standard_deviation) );
				}
				return result;
			},
			prevalence_quote_hospitalized_intervention(){
				let result = [];
				for(var i=0; i<=this.length; i++){
				
					if(i < this.intervention.value + this.delay_hospitalized){
						result.push( this.normal_multiplier/this.hospitalized_reducer * pdf(i, this.peak.value+this.delay_hospitalized, this.standard_deviation) );
					}else{
						let min = this.intervention.value+this.delay_hospitalized;
						let range = this.length-min;
						let differential = ((i-min)/range) * (this.hospitalized_reducer_intervention-this.hospitalized_reducer);
						
						result.push( this.normal_multiplier_intervention/(this.hospitalized_reducer+differential) * pdf(i, this.peak.value+this.delay_hospitalized, this.standard_deviation_intervention) );
					}
				}
				return result;
			},
			prevalence_quote_deceased(){
				let result = [];
				for(var i=0; i<=this.length; i++){
					result.push( this.normal_multiplier/this.deceased_reducer * pdf(i, this.peak.value+this.delay_deceased, this.standard_deviation) );
				}
				return result;
			},
			prevalence_quote_deceased_intervention(){
				let result = [];
				for(var i=0; i<=this.length; i++){
				
					if(i <= this.intervention.value + this.delay_deceased){
						result.push( this.normal_multiplier/this.deceased_reducer * pdf(i, this.peak.value+this.delay_deceased, this.standard_deviation) );
					}else{
						let min = this.intervention.value+this.delay_deceased;
						let range = this.length-min;
						let differential = ((i-min)/range) * (this.deceased_reducer_intervention-this.deceased_reducer);
						
						result.push( this.normal_multiplier_intervention/(this.deceased_reducer+differential) * pdf(i, this.peak.value+this.delay_deceased, this.standard_deviation_intervention) );
					}
				}
				return result;
			},
			
			
			
		},
		async mounted(){
			this.updateData();
			this.setup();
			this.animate();
		
			//Eventi
			window.addEventListener( 'resize', this.resize );
			this.resize();
		},
		methods: {
			curveFunction(x){
				return this.normal_multiplier * pdf(x, this.peak.value, this.standard_deviation);
			},
			curveFunctionIntervention(x){
				return this.normal_multiplier_intervention * pdf(x, this.peak.value, this.standard_deviation_intervention);
			},
			curveFunctionHospitalized(x){
				return this.normal_multiplier/this.hospitalized_reducer * pdf(x, this.peak.value+this.delay_hospitalized, this.standard_deviation);
			},
			curveFunctionHospitalizedIntervention(x){
				let min = this.intervention.value+this.delay_hospitalized;
				let range = this.length-min;
				let differential = ((x-min)/range) * (this.hospitalized_reducer_intervention-this.hospitalized_reducer);
				
				return this.normal_multiplier_intervention/(this.hospitalized_reducer+differential) * pdf(x, this.peak.value+this.delay_hospitalized, this.standard_deviation_intervention);
			},
			curveFunctionDeceased(x){
				return this.normal_multiplier/this.deceased_reducer * pdf(x, this.peak.value+this.delay_deceased, this.standard_deviation);
			},
			curveFunctionDeceasedIntervention(x){
				let min = this.intervention.value+this.delay_deceased;
				let range = this.length-min;
				let differential = ((x-min)/range) * (this.deceased_reducer_intervention-this.deceased_reducer);
				
				return this.normal_multiplier_intervention/(this.deceased_reducer+differential) * pdf(x, this.peak.value+this.delay_deceased, this.standard_deviation_intervention);
			},
			
			incidenceAbsolute(prevalence_quote){
				let result = [];
				let pa = prevalence_quote.map( x => x*this.population/100);
				
				for(var i=0; i<=this.length; i++){
					let value = 0;
					if(i>0){
						value = pa[i]-pa[i-1]+pa[i-1]/this.sickness_duration
					}
					result.push(value);
				}
				return result;
			},
			totalQuote(prevalence_quote){
				let total = 0;
				let ia = this.incidenceAbsolute(prevalence_quote);
				
				for(var i=0; i<=this.length; i++){
					if(i<=this.time && ia[i] > 0){
						total += ia[i];
					}
				}
				
				return Math.round(total);
			},
			
			updateData(){
				let data = [];
				for(var i=0; i<=this.length; i++){
					data.push({x:i, y:this.curveFunction(i)});
				}
				this.data = data;
			},
			setup(){
				this.graph_sizes.width = this.$refs.graph.offsetWidth;
				const width = this.graph_sizes.width;
				const height = width/2;
				
				let gs = this.graph_sizes;

				// Declare the x (horizontal position) scale.
				x_scale = d3.scaleLinear()
					.domain([0, this.length])
					.range([gs.margin_left, width - gs.margin_right]);
					
				// Declare the y (vertical position) scale.
				y_scale = d3.scaleLinear()
					.domain([0, 8])
					.range([height - gs.margin_bottom - gs.gap, gs.margin_top + gs.gap]);

				// Create the SVG container.
				svg = d3.select("#graph")
					.append("svg")
					.attr("width", width)
					.attr("height", height);

				// Add the x-axis.
				svg.append("g")
					.attr("class", "x-axis1")
					.attr("transform", `translate(0,${height - gs.margin_bottom})`)
					.call(d3.axisBottom(x_scale))
					.call( g => g.selectAll(".tick line")
						.attr("stroke", '#BFC8DB80')
						.attr("stroke-dasharray", '2')
						.attr("y1", -(gs.gap+5))
					);
					
				svg.append("g")
					.attr("class", "x-axis2")
					.attr( "transform", `translate(0, ${gs.margin_top})` )
					.call(d3.axisTop(x_scale))
					.call( g => g.selectAll(".tick line")
						.attr("stroke", '#BFC8DB80')
						.attr("stroke-dasharray", '2')
						.attr("y1", gs.gap+5)
					);
					

				// Add the y-axis.
				svg.append("g")
					.attr( "class", "y-axis")
					.attr( "transform", `translate(${gs.margin_left},0)` )
					.call( d3.axisLeft(y_scale) )
					.call( g => g.selectAll(".tick line")
						.attr("stroke", '#BFC8DB80')
						.attr("stroke-dasharray", '2')
						.clone()
						.attr("class", 'dashed-line-y')
						.attr("x2", gs.width)
					);
					
				//Data
				this.dots = svg.append("g")
					.attr("class", "dots")
					.selectAll("dot")
					.data(this.rand_data)
					.enter()
					.append("circle")
						.attr("class", 'dot' )
						.attr("cx", d => x_scale(d.x) )
						.attr("cy", d => y_scale(d.y) )
						.attr("r", 3)
						.style("stroke", "#BD5EFD")
						.style("fill", "#BD5EFD33")
				
				this.curve = svg.append("path")
					.datum(this.data)
					.attr("fill", "none")
					.attr("stroke", "#BD5EFD")
					.attr("stroke-width", 3)
					.attr("d", d3.line()
						.curve(d3.curveBasis) 
						.x( d => x_scale(d.x) )
						.y( d => y_scale(d.y) )
					)
				
				this.curve_intervention = svg.append("path")
					.datum(this.data_intervention)
					.attr("fill", "none")
					.attr("stroke", "#BD5EFD")
					.attr("stroke-dasharray", 2)
					.attr("stroke-width", 3)
					.attr("d", d3.line()
						.curve(d3.curveBasis) 
						.x( d => x_scale(d.x) )
						.y( d => y_scale(d.y) )
					)
				
				this.hospitalized_curve = svg.append("path")
					.datum(this.hospitalized_data)
					.attr("fill", "none")
					.attr("stroke", "#FFA01C")
					.attr("stroke-width", 3)
					.attr("d", d3.line()
						.curve(d3.curveBasis) 
						.x( d => x_scale(d.x) )
						.y( d => y_scale(d.y) )
					)
				
				this.hospitalized_curve_intervention = svg.append("path")
					.datum(this.hospitalized_data_intervention)
					.attr("fill", "none")
					.attr("stroke", "#FFA01C")
					.attr("stroke-dasharray", 2)
					.attr("stroke-width", 3)
					.attr("d", d3.line()
						.curve(d3.curveBasis) 
						.x( d => x_scale(d.x) )
						.y( d => y_scale(d.y) )
					)
				
				this.deceased_curve = svg.append("path")
					.datum(this.deceased_data)
					.attr("fill", "none")
					.attr("stroke", "#FF5050")
					.attr("stroke-width", 3)
					.attr("d", d3.line()
						.curve(d3.curveBasis) 
						.x( d => x_scale(d.x) )
						.y( d => y_scale(d.y) )
					)
				
				this.deceased_curve_intervention = svg.append("path")
					.datum(this.deceased_data_intervention)
					.attr("fill", "none")
					.attr("stroke", "#FF5050")
					.attr("stroke-dasharray", 2)
					.attr("stroke-width", 3)
					.attr("d", d3.line()
						.curve(d3.curveBasis) 
						.x( d => x_scale(d.x) )
						.y( d => y_scale(d.y) )
					)
				
				
			},
			resize(){
				if( this.$refs.graph == null) return;
				
				this.graph_sizes.width = this.$refs.graph.offsetWidth;
				this.graph_sizes.height = this.graph_sizes.width/2;
				
				let gs = this.graph_sizes;
				
				x_scale.range([gs.margin_left, gs.width - gs.margin_right]);
				y_scale.range([gs.height - gs.margin_bottom - gs.gap, gs.margin_top + gs.gap]);
				
				svg.selectAll(".x-axis1")
					.attr("transform", `translate(0,${gs.height - gs.margin_bottom})`)
					.call(d3.axisBottom(x_scale));
					
				svg.selectAll(".x-axis2")
					.attr( "transform", `translate(0, ${gs.margin_top})` )
					.call(d3.axisTop(x_scale));
				
				svg.selectAll(".y-axis")
					.attr("transform", `translate(${gs.margin_left},0)`)
					.call(d3.axisLeft(y_scale));
				
				svg.selectAll(".dashed-line-y")
					.attr("x2", gs.width);
				
				svg.selectAll(".domain")
					.remove();
					
				//Scales
				this.scales.top = y_scale(Math.max(8, Math.ceil(this.max_y)));
				this.scales.bottom = y_scale(0);
				this.scales.left = x_scale(0);
				this.scales.right = x_scale(this.length);
				this.scales.min_intervention = x_scale(this.intervention.min);
				this.scales.max_intervention = x_scale(Math.floor(this.peak.value/2));
				this.scales.min_peak = x_scale(this.peak.min);
				this.scales.max_peak = x_scale(this.peak.max);
				this.updateIntervention();
				
				//Update data
				this.updateGraph();
			},
			updateIntervention(){
				this.intervention.scale_value = x_scale(this.intervention.value);
				
				//Update data
				this.updateGraph();
			},
			updateScale(){
				const width = this.graph_sizes.width;
				const height = width/2;
				
				let gs = this.graph_sizes;
				
				y_scale = d3.scaleLinear()
					.domain([0, Math.max(8, Math.ceil(this.max_y))])
					.range([height - gs.margin_bottom - gs.gap, gs.margin_top + gs.gap]);
					
				svg.select(".y-axis").remove();
				
				svg.append("g")
					.attr( "class", "y-axis")
					.attr( "transform", `translate(${gs.margin_left},0)` )
					.call( d3.axisLeft(y_scale) )
					.call( g => g.selectAll(".tick line")
						.attr("stroke", '#BFC8DB80')
						.attr("stroke-dasharray", '2')
						.clone()
						.attr("class", 'dashed-line-y')
						.attr("x2", gs.width)
					);
					
				this.resize();
			},
			updatePeak(){
				this.updateScale();
				this.peak.scale_value = x_scale(this.peak.value);
				this.scales.max_intervention = x_scale(Math.floor(this.peak.value/2));
				
				if(this.intervention.value > this.peak.value/2){
					this.intervention.value = Math.floor(this.peak.value/2);
					this.updateIntervention();
				}
				
				this.updateData();
				this.updateGraph();
			},
			updateGraph(){
				let time = this.time+1;
				
				this.curve.datum(this.data.slice(0, time));
				this.dots.data(this.rand_data.slice(0, time));
				this.curve_intervention.datum(this.data_intervention.slice(0, Math.max(0,time-this.intervention.value)));
				this.hospitalized_curve.datum(this.hospitalized_data.slice(0, time));
				this.hospitalized_curve_intervention.datum(this.hospitalized_data_intervention.slice(0, Math.max(0,time-(this.intervention.value+this.delay_hospitalized))));
				this.deceased_curve.datum(this.deceased_data.slice(0, time));
				this.deceased_curve_intervention.datum(this.deceased_data_intervention.slice(0, Math.max(0,time-(this.intervention.value+this.delay_deceased))));
			
				this.dots
					.attr("cx", d => d.x < this.time ? x_scale(d.x) : -100 )
					.attr("cy", d => y_scale(d.y) )
			
				this.curve.attr("d", d3.line()
					.curve(d3.curveBasis) 
					.x( d => x_scale(d.x) )
					.y( d => y_scale(d.y) )
				)
				this.curve_intervention.attr("d", d3.line()
					.curve(d3.curveBasis) 
					.x( d => x_scale(d.x) )
					.y( d => y_scale(d.y) )
				)
				this.hospitalized_curve.attr("d", d3.line()
					.curve(d3.curveBasis) 
					.x( d => x_scale(d.x) )
					.y( d => y_scale(d.y) )
				)
				this.hospitalized_curve_intervention.attr("d", d3.line()
					.curve(d3.curveBasis) 
					.x( d => x_scale(d.x) )
					.y( d => y_scale(d.y) )
				)
				this.deceased_curve.attr("d", d3.line()
					.curve(d3.curveBasis) 
					.x( d => x_scale(d.x) )
					.y( d => y_scale(d.y) )
				)
				this.deceased_curve_intervention.attr("d", d3.line()
					.curve(d3.curveBasis) 
					.x( d => x_scale(d.x) )
					.y( d => y_scale(d.y) )
				)
			},
			
			
			changeTime(){
				this.updateData();
				this.updateGraph();
			},
			playAnimation(){
				this.time = 0;
				tween = new Tween(this, false) 
					.to({time:this.length}, 2500) 
					.easing(Easing.Linear.InOut) 
					.onUpdate(this.changeTime)
					.start()
			},
			animate(time) {
				if(tween){
					tween.update(time)
				}
				requestAnimationFrame(this.animate)
			}
		},
	}
</script>

<style lang="scss">
	@import './assets/styles/base.scss';
	
	main{
		background: black;
		color: white;
		min-height: 100vh;
		padding: 60px;
		
		#graph{
			position: relative;
			padding-top: 50%;
			
			.day-label{
				position: absolute;
				left: 0;
				text-align: right;
				width: 90px;
				color: #BFC8DB80;
				
				&:nth-child(1){
					top: -1px;
				}
				&:nth-child(2){
					bottom: -1px;
				}
			}
			
			.intervention-label{
				position: absolute;
				bottom: 30px;
				z-index: 1;
				width: 90px;
				text-align: right;
				
			}
			.intervention-fade{
				position: absolute;
				background: linear-gradient( to right,  #FFFFFF1A, #FFFFFF00 );
				
			}
			.intervention{
				position: absolute;
				height: 6px;
				bottom: 34px;
				z-index: 1;
			}
			.peak-label{
				position: absolute;
				top: 30px;
				z-index: 1;
				width: 90px;
				text-align: right;
				color: #BD5EFD;
				
			}
			.peak{
				position: absolute;
				height: 6px;
				top: 34px;
				z-index: 1;
			}
				
			svg:not(.play){
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				
				text{
					font-family: "Geist Mono", monospace;
					color: #BFC8DB80;
					font-size: 1rem;
				}
				
				.x-axis{
				
				}
				.y-axis{
					text{
						transform: translateX(-10px);
					}
				}
			}
		}
		
		.play{
			position: absolute;
			bottom: -125px;
			width: 40px;
			height: 40px;
			cursor: pointer;
		}
		
		.data{
			.index{
				text-transform: uppercase;
				
				.entry{
					display: flex;
					align-items: center;
					gap: 20px;
					width: 180px;
					
					svg{
						width: 40px;
					}
				}
			}
		}
		
		.side-bar{
			flex-basis: min-content;
			
			.info{
				padding: 40px;
				background: #292C32;
				color: 	#BFC8DB;
				border-radius: 10px;
				
				.text{
					line-height: 1.3;
				}
			
				table{
					width: 100%;
					border-collapse: collapse;
					text-transform: uppercase;
					
					tr{
						
						th,td{
							text-align: right;
							padding: 10px 0;
						}
						td{
							border-top: 1px solid #BFC8DB;
							font-size: 4.285rem;
							padding-left: 40px;
							
							&.small{
								font-size: 2.142rem;
							}
							
							&:first-child{
								text-align: left;
								font-size: 1rem;
								padding-left: 0px;
							}
							
							span{	
								display: block;
								min-width: 6ch;
							}
						}
						
						&.blue{
							td{
								border-color: #BD5EFD;
								
								&:first-child{
									color: #BD5EFD;
								}
							}
						}
						
						&.yellow{
							td{
								border-color: #FFA01C;
								
								&:first-child{
									color: #FFA01C;
								}
							}
						}
						
						&.red{
							td{
								border-color: #FF5050;
								
								&:first-child{
									color: #FF5050;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
